import {TransactionCalcResponseResultData} from "../services/api-types/exchange.types";

export const TRANSACTION_NULL_DATA: TransactionCalcResponseResultData = {
  blAmount: 0,
  blFee: 0,
  blFeeQuick: 0,
  blAmountQuick: 0,
  creditAmount: 0,
  creditAmountQuick: 0,
  creditCurrency: 'USDT',
  creditCurrencyQuick: 'USDT',
  plFee: 0,
  plFeeQuick: 0,
  debitAmount: 0,
  debitCurrency: 'UZS',
  rate: 0,
  plAmount: 0,
  plAmountQuick: 0,
  time: 0,
  timeQuick: 0,
  debitAmountQuick: 0,
  debitCurrencyQuick: 'UZS',
  calcAmount: 0
}
